import {useEffect, useState} from "react";
import {CellBase, Matrix, Spreadsheet} from "react-spreadsheet";
import {Dialog} from "@blueprintjs/core";
import GeoJSONSource from "../sources/geojson_source";

interface Props {
  geojsonSource: GeoJSONSource
  isOpen: boolean;
  onClose: () => void;
}

export function TranslationDialog({isOpen, onClose, geojsonSource}: Props) {
  const [hasChanges, setHasChanges] = useState(false);

  const columnLabels = ["Feature ID", "Title EN", "Title AR", "Description EN", "Description AR"];

  const pois = geojsonSource.fullData.features
    .filter(f => f.properties && f.isPoint)
    .map(f => [
      { value: f.properties.id },
      { value: f.properties.title_i18n?.en ?? '' },
      { value: f.properties.title_i18n?.ar ?? '' },
      { value: f.properties.description_i18n?.en ?? '' },
      { value: f.properties.description_i18n?.ar ?? '' }
    ]);

  const [data, setData] = useState<Matrix<CellBase>>(pois);

  useEffect(() => {
    console.log('on spreadsheet change');
    setHasChanges(true);
  }, [data]);

  return <Dialog isOpen={false} onClose={onClose} style={{ width: '98%' }}>
    <Spreadsheet
      className={"translation-spreadsheet"}
      data={data}
      columnLabels={columnLabels}
      onChange={setData}
    />
  </Dialog>
}
